import React from 'react';

import { MobileFilterWrapper } from '@/modules/CarsStock/components/common.styles';
import StockFilterRange from '@/components/StockFilterRange';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarPrice,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';

function PriceFilter() {
  const dispatch = useTypedDispatch();
  const selectedPrice =
    useTypedSelector(getSelectedFilters).selectedParams.selectedPriceRange;

  const handleBlurPrice = (price: RangeType) => {
    dispatch(setCarPrice(price));
    dispatch(setPage(1));
  };

  return (
    <MobileFilterWrapper>
      <StockFilterRange
        label="Цена, BYN"
        values={selectedPrice}
        onBlur={handleBlurPrice}
      />
    </MobileFilterWrapper>
  );
}

export default PriceFilter;
